import { useContext } from "react";
import { ActiveUtterancesContext } from "@/providers/ScrollManagerContext/ActiveUtterancesContext";
import { ScrollManagerContext } from "@/providers/ScrollManagerContext/ScrollManagerProvider";

export const useScrollManager = () => useContext(ScrollManagerContext);

export const useActiveUtterances = () => useContext(ActiveUtterancesContext);
